import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import RouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router';
import { Alert } from 'reactstrap';
import PropTypes from 'prop-types';

import { modelOf } from '../../../prop-types';
import PageTitle from '../../common/PageTitle';
import SEOTitle from '../../head/SEOTitle';
import UnexpectedError from '../../loader/UnexpectedError';
import globalTranslations from '../../../i18n/globalTranslations';
import RouteService from '../../../services/RouteService';
import Paths from '../../../types/Paths';
import HelperNavigation from '../../common/HelperNavigation';
import CustomerUserStore from '../../../store/CustomerUserStore';
import UserForm from '../../user/UserForm';
import AccountStore from '../../../store/AccountStore';
import BalanceUserForm from '../../user/BalanceUserForm';

const customerUserBreadcrumbs = [
  {
    text: <FormattedMessage {...globalTranslations.myAccount} />,
    url: Paths.MyAccount
  },
  {
    text: <FormattedMessage {...globalTranslations.userListTitle} />,
    url: Paths.MyAccountUserList
  },
  {
    text: <FormattedMessage {...globalTranslations.addNewUserTitle} />,
    url: Paths.MyAccountUserNew
  }
];

const balanceUserBreadcrumbs = [
  {
    text: <FormattedMessage {...globalTranslations.myAccount} />,
    url: Paths.MyAccountBalanceUser
  }
];

@observer
export class MyAccountUserNew extends Component {
  state = {
    loading: false,
    error: null,
    requestId: 0
  };

  getBreadcrumbsPath = () => {
    const { routeService, accountStore } = this.props;
    const breadcrumbs = accountStore.isBalanceBuyer
      ? balanceUserBreadcrumbs
      : customerUserBreadcrumbs;
    return routeService.transformBreadCrumbs(breadcrumbs);
  };

  saveCustomerUser = (user) => {
    const { customerUserStore } = this.props;
    this.setState({ loading: true });

    user.isActive = !!user.isActive;
    user.notifyUser = !!user.notifyUser;
    user.allowUserCreateAddress = !!user.allowUserCreateAddress;

    customerUserStore
      .saveUser(user)
      .then(() => {
        this.setState({ error: null, loading: false });
        customerUserStore.loadUsers();
        this.navigateToCustomerUserList();
      })
      .catch((error) =>
        this.setState({
          error: error,
          requestId: this.state.requestId + 1,
          loading: false
        })
      );
  };

  navigateToCustomerUserList() {
    const { history, routeService } = this.props;
    history.push(routeService.getPath(Paths.MyAccountUserList));
  }

  saveBalanceUser = (user) => {
    const { customerUserStore } = this.props;
    this.setState({ loading: true });
    customerUserStore
      .saveBalanceUser(user)
      .then(() => {
        this.setState({ error: null, loading: false });
        customerUserStore.loadBalanceUsers();
        this.navigateToBalanceUserList();
      })
      .catch((error) =>
        this.setState({
          error: error,
          requestId: this.state.requestId + 1,
          loading: false
        })
      );
  };

  navigateToBalanceUserList() {
    const { history, routeService } = this.props;
    history.push(routeService.getPath(Paths.MyAccountBalanceUser));
  }

  renderError = () => {
    const { error, requestId } = this.state;
    const status = _.get(error, 'response.status');
    return status === 422 ? (
      <Alert
        className="MyAccountUserNew__errors"
        color="danger"
        key={requestId}
      >
        {_.flatten(Object.values(error.response.data)).map((message) => (
          <div key={message}>{message}</div>
        ))}
      </Alert>
    ) : (
      <UnexpectedError />
    );
  };

  render() {
    const { accountStore } = this.props;
    const { error, loading } = this.state;

    return (
      <div className="MyAccountUserNew">
        <SEOTitle title={globalTranslations.addNewUserTitle} />
        <HelperNavigation breadcrumbsPath={this.getBreadcrumbsPath()} />
        <PageTitle>
          <FormattedMessage {...globalTranslations.addNewUserTitle} />
        </PageTitle>
        {error && this.renderError()}
        {accountStore && accountStore.isBalanceBuyer ? (
          <BalanceUserForm
            loading={loading}
            buttonText={
              <FormattedMessage {...globalTranslations.addNewUserTitle} />
            }
            onSubmit={this.saveBalanceUser}
          />
        ) : (
          <UserForm
            loading={loading}
            buttonText={
              <FormattedMessage {...globalTranslations.addNewUserTitle} />
            }
            onSubmit={this.saveCustomerUser}
          />
        )}
      </div>
    );
  }
}

MyAccountUserNew.propTypes = {
  customerUserStore: modelOf(CustomerUserStore).isRequired,
  history: RouterPropTypes.history.isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
  accountStore: modelOf(AccountStore).isRequired
};

export default inject(
  'accountStore',
  'customerUserStore',
  'routeService',
  'accountStore'
)(withRouter(MyAccountUserNew));



// WEBPACK FOOTER //
// ./src/components/my-account/MyAccountUserNew/index.jsx